import React, { useState, useEffect } from "react";
import { useEmployees } from "../../hooks/useEmployees";
import { usePayroll } from "../../hooks/usePayroll";
import PayrollTable from "./PayrollTable";
import PayrollFormModal from "./PayrollFormModal";
import LoadingSpinner from "../../../../Component/Shared/LoadingSpinner/LoadingSpinner";
import styles from "./PayrollTab.module.css";

const PayrollTab = () => {
  const { employees } = useEmployees();
  const [selectedEmployeeId, setSelectedEmployeeId] = useState("");
  const { payrolls, loading, error, loadPayrolls, addPayroll } = usePayroll();
  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    if (selectedEmployeeId) loadPayrolls(selectedEmployeeId);
  }, [selectedEmployeeId, loadPayrolls]);

  const selectedEmployee = employees.find((e) => e.id === Number(selectedEmployeeId));

  const handleAddPayroll = async (formData) => {
    await addPayroll({ ...formData, employeeId: Number(selectedEmployeeId) }, selectedEmployeeId);
    setModalOpen(false);
  };

  return (
    <div className={styles.container}>
      <div className={styles.toolbar}>
        <select className={styles.select} value={selectedEmployeeId} onChange={(e) => setSelectedEmployeeId(e.target.value)}>
          <option value="">-- اختر موظف --</option>
          {employees.map((emp) => (
            <option key={emp.id} value={emp.id}>{emp.fullName} - {emp.jobTitle}</option>
          ))}
        </select>

        <button className={styles.addBtn} disabled={!selectedEmployeeId} onClick={() => setModalOpen(true)}>
          + إضافة مرتب/عمولة
        </button>
      </div>

      {!selectedEmployeeId && <div className={styles.empty}>اختر موظفًا لعرض سجل المرتبات الخاص به</div>}
      {error && <div className={styles.error}>{error}</div>}

      {selectedEmployeeId && (
        loading ? <LoadingSpinner text="جاري تحميل سجل المرتبات..." /> : <PayrollTable payrolls={payrolls} />
      )}

      {modalOpen && (
        <PayrollFormModal employee={selectedEmployee} onSubmit={handleAddPayroll} onClose={() => setModalOpen(false)} />
      )}
    </div>
  );
};

export default PayrollTab;